/* tslint:disable:max-line-length */
import {FuseNavigationItem} from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'basic',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/home-page'
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'basic',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/home-page'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'basic',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/home-page'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'basic',
        title: 'Home',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/home-page'
    }
];
